//URL
import configData from "../../../config.json";
//Otros
import axios from "axios";
import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { authenticationService } from "services/authentication.service";
import { alertService } from "components/Varios/alert_service";
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";
//Componentes
import Cargando from 'components/Varios/Cargando'
import SelectItem from "components/Varios/select";
import {
    Row, Col, FormGroup, Label, Container, Input, Modal, ModalBody

} from 'reactstrap';

import Select from 'react-select';

//scss
import "./solicitudcertificados.scss"
import { Button, } from "react-bootstrap";
import TableSolicitudesCertificados from "./TableSolicitudesCertificados";
//IMAGENES CERTIFICADOS
import certificado_civil from "../../../assets/img/certificados/CERTIFICADO_CONTRATO_CIVIL.png"
import calificaciones_cenacad from "../../../assets/img/certificados/CALIFICACIONES CENACAD.png"
import certificado_materias_dictadas from "../../../assets/img/certificados/MATERIAS DICTADAS.png"
import certificado_actividades_trabajo from "../../../assets/img/certificados/ACTIVIDADES TRABAJO.png"
import certificado_actividades_politecnicas from "../../../assets/img/certificados/ACTIVIDADES POLITECNICAS.png"
import certificado_ingresos_anuales from "../../../assets/img/certificados/INGRESOS ANUALES.png"
import certificado_laboral_detallado from "../../../assets/img/certificados/LABORAL DETALLADO.png"
//PDFS CERTIFICADOS
import certificadocenacadpdf from "assets/pdf/FORMATO CERTIFICADO CALIFICACIONES CENACAD.pdf";
import certificadocontratoscivilespdf from "../../../assets/pdf/FORMATO CERTIFICADO CONTRATOS CIVILES.pdf";


import certificadoactividadestrabajopdf from "../../../assets/pdf/FORMATO CERTIFICADO DE ACTIVIDADES DE PERSONAL ADMINISTRATIVO.pdf";

import certificadoactividadespolitecnicaspdf from "../../../assets/pdf/FORMATO CERTIFICADO DE ACTIVIDADES POLITÉCNICAS.pdf";

import certificadoacumulaciondecimospdf from "../../../assets/pdf/FORMATO CERTIFICADO DE ACUMULACION DE DECIMOS.pdf";

import certificadomateriasdictadaspdf from "../../../assets/pdf/FORMATO CERTIFICADO DE MATERIAS DICTADAS.pdf";

import certificadoingresosanualespdf from "../../../assets/pdf/FORMATO CERTIFICADO DE TOTAL DE INGRESOS ANUALES.pdf";
import certificadolaboraldetalladopdf from "../../../assets/pdf/FORMATO CERTIFICADO LABORAL DETALLADO.pdf";






import InputNumber from "components/Varios/InputNumber";
import PDFViewer from "components/Varios/PDFViewer";
import { ID_REGIMEN_CONTRATO_CIVIL } from "components/Sidebar/Sidebar_Principal_Submenu";
import { authHeaderWithUserData } from "helpers/auth-header";
import ModalConfirmacion from "components/Varios/Modals/ModalConfirmacion";
import { ResponseRequest } from "components/Types/GeneralTypes";
import { SelectCombo } from "components/Types/GeneralTypes";
import Datepicker from "components/Varios/Datepicker";
import MonthDatePicker from "components/Varios/DatePicker/MonthDatePicker";
import { GetTodayDateForDatePicker, ObtenerFechaTimeZoneLocalISO, PruebaSolucion, PruebaSolucion2, sendDateToBackend } from "functions/DatesFunctions";
import { parseDatetoFormatSend } from "../Vacaciones/Planificacion Vacaciones/PlanificacionVacaciones";
import format from "date-fns-tz/format/index.js";
import ComboIncluirOpcionCertificado from "./ComboIncluirOpcionCertificado";
import { showAlertAviso } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";


const TIPO_CONTRATO_NOMBRAMIENTO = "NOMBRAMIENTO";

export type SolicitudCertificado = {
    idsolcertth: number,
    idcertificadotipo: number,
    dirigido?: string,
    idpersonasolicita: number,
    estadosolicitud: string,
    fechasolicitud: Date,
    observaciones?: string,
    idcontrato?: string,
    idusuarioanalista?: number,
    idcertificadoth?: number,
    estadoCertificado?: string,
    certificadoVigente?: boolean,
    fechaHora?: Date,
    referenciaCertificado?: string,
    nombres?: string,
    nombreCertificado: string,
    automatizado: boolean,

}

type ContratosUsuarios = {
    idContrato: number,
    cargo: string,
    noContrato: string,
    tipoContrato: string,
    idRegimen: number,
    regimen: string,
    tipoVinculoMovimiento: string,
    idTipoAccionPersonal?: number,
    nombreTipoAccionPersonal?: string,
    esRemunerado?: string,
    idTipoLicencia?: number,
    tipoLicencia?: string
}

enum TipoRolPago {
    SUELDOMENSUAL,
    HORASEXTRAS,
    DECIMOSMENSUALIZADOS,
    DECIMOTERCER,
    DECIMOCUARTO,
    FONDORESERVA,
    SUBSIDIO,
    SUBROGACIONES
}



const rolesPagoKeys = Object.keys(TipoRolPago).filter((e) => isNaN(Number(e)));
const rolesPagoValue = Object.values(TipoRolPago).filter((e) => !isNaN(Number(e)));

function ParseNombreEnumRolesPago(nombreKey: string) {
    var valor: TipoRolPago = TipoRolPago[nombreKey];
    var nombre = "";
    switch (valor) {
        case TipoRolPago.SUELDOMENSUAL:
            nombre = "SUELDO MENSUAL";
            break;
        case TipoRolPago.HORASEXTRAS:
            nombre = "HORAS EXTRAS";
            break;
        case TipoRolPago.DECIMOSMENSUALIZADOS:
            nombre = "DÉCIMOS MENSUALIZADOS";
            break;
        case TipoRolPago.DECIMOTERCER:
            nombre = "DÉCIMO TERCER SUELDO";
            break;
        case TipoRolPago.DECIMOCUARTO:
            nombre = "DÉCIMO CUARTO SUELDO";
            break;
        case TipoRolPago.FONDORESERVA:
            nombre = "FONDO DE RESERVA";
            break;
        case TipoRolPago.SUBSIDIO:
            nombre = "SUBSIDIO";
            break;
        case TipoRolPago.SUBROGACIONES:
            nombre = "SUBROGACIONES";
            break;
        default:
            break;
    }
    return nombre;
}

type ParametrosContratoLaboral = {
    IdContrato: number,
    IdRegimenLaboral: number,
    IncluirSueldo: boolean,
}

export type OpcionesContratacionesCiviles = {

    IncluirHonorarios: boolean,
    IncluirTipoContrato: boolean,
    IncluirActividades: boolean,
    AnioInicio: string,
    AnioFin: string

}

type ParametrosNewCertificado = {
    Dirigido: string,
    VistaPrevia: boolean,
    Contrato?: ParametrosContratoLaboral | undefined,
    OpcionesContratacionesCiviles?: OpcionesContratacionesCiviles
}


type DatosCertificadoRolesDePago = {
    fechaDesde: Date | string,
    fechaHasta: Date | string,
    rolesDeseados: Array<TipoRolPago>
}

type DatosCertificadoTrabajo = {
    dirigido: string,
    incluirSueldo: boolean
}

type DatosCertificadoEvaluacionIntegral = {
    dirigido: string
    fechaDesde: number,
    todasFechas: boolean
}

type DatosCertificadoConAnios = {
    dirigido: string
    fechaDesde?: number,
    fechaHasta?: number,
    todasFechas: boolean
}

type TiposCertificados = {
    idCertificado: number,
    descripcion: string,
    remitente: boolean,
    regimenespermitidos: Array<number>,
    requierecontrato: boolean,
    tienevistaprevia: boolean,
    detalle: string
}

type InformacionCertificadoEvaluacionIntegral = {
    listaanios: number[]
}

type DatosCertificadosAniosRequest = {
    fechaDesde?: number,
    fechaHasta?: number,
    todasFechas: boolean,
    terminos?: string,
}


export type AniosDatosSolicitud = {
    anios_desde: number[],
    anios_hasta: number[],
    terminoos?: string[]
}

type InformacionUsuarioCertificados = {
    nombres: string,
    identificacion: string
}

type InformacionCertificados = {
    contratosUsuario: Array<ContratosUsuarios>
    tiposCertificados: Array<TiposCertificados>
    informacionUsuario: InformacionUsuarioCertificados,
    estaDeVacaciones: boolean,
    estaDeLicencia: boolean,
    estaDeLicenciaEducacion: boolean,
    estaDeComision: boolean,
    esRemunerado: boolean,
}

type RequestSolicitudCertificado = {
    idCertificadoTipo: number,
    dirigido?: string,
    idContrato?: number,
    observaciones?: string,
    datosCertificadoAnios?: DatosCertificadosAniosRequest,
    datosCertificadoLaboral?: ParametrosNewCertificado,
    datosCertificadoRoles?: DatosCertificadoRolesDePago
}
export type AnularCertificadoAccesor = {
    idSolicitud: number,
    estadosolicitud: string,
}

export type HistoriaSolicitudesCertificadoColumn = {
    tip: string,
    fecs: Date,
    obs?: string,
    est: String,
    cert?: CertificadoDescarga,
    estc?: string,
    noms?: string,
    dir?: string,
    anularSolicitud: AnularCertificadoAccesor,


}

export type CertificadoDescarga = {
    referencia?: string,
    estadocertificado?: string
    idcertificado?: number,
    certificadoVigente?: boolean,
    certificadoAutomatizado: boolean,
    nombreSolicita?: string,
    nombreTipoCertificado: string,
    idTipoCertificado: number,
    estadoSolicitud: string,
    fechaSolicitudFormato: string,
    analistaEmitio: string,
    fechaEmisionCertificado: string

}

export const functionFormatISODate = (fecha: string) => {
    var fecha_dividida: string[] = fecha.split("T")[0].split("-");
    return (fecha_dividida[2] + "/" + fecha_dividida[1] + "/" + fecha_dividida[0])
}
export const ID_CERTIFICADO_TRABAJO = 1;
export const ID_CERTIFICADO_EVALUACIONINTEGRAL = 3



export const ID_CERTIFICADO_CIVIL = 22;
export const ID_CERTIFICADO_MATERIAS_DICTADAS = 23
export const ID_CERTIFICADO_CALIFICACIONES_CENACAD = 24
export const ID_CERTIFICADO_ROLES_PAGO = 30;
const ID_CERTIFICADO_ACTIVIDADES_POLITECNICAS = 25
const ID_CERTIFICADO_ACTIVIDADES_DESEMPENADAS_TRABAJO = 26
const ID_CERTIFICADO_LABORAL_DETALLADO = 21
const ID_CERTIFICADO_ACUMULACION_DECIMOS = 28;
const ID_CERTIFICADO_PERSONALIZADO = 29;
const ID_CERTIFICADO_INGRESOS_ANUALES = 27;
export const ID_CERTIFICADO_CONTRATACIONES_CIVILES = 50;

const IDS_certificados_piden_anios = [
    ID_CERTIFICADO_EVALUACIONINTEGRAL,
    ID_CERTIFICADO_MATERIAS_DICTADAS,
    ID_CERTIFICADO_CALIFICACIONES_CENACAD,
    ID_CERTIFICADO_ACTIVIDADES_POLITECNICAS,
    ID_CERTIFICADO_ACTIVIDADES_DESEMPENADAS_TRABAJO,
    ID_CERTIFICADO_CONTRATACIONES_CIVILES
];

const IDS_certificados_piden_un_anio = [
    ID_CERTIFICADO_EVALUACIONINTEGRAL
]
const IDS_certificados_muestran_listado_anios = [ID_CERTIFICADO_EVALUACIONINTEGRAL, ID_CERTIFICADO_CALIFICACIONES_CENACAD, ID_CERTIFICADO_MATERIAS_DICTADAS, ID_CERTIFICADO_CONTRATACIONES_CIVILES];
// const IDS_certificados_piden_terminos = [ID_CERTIFICADO_MATERIAS_DICTADAS];
const IDS_certificados_piden_terminos = [];

export function parseTipoCertificado(tipo: number) {

    const CERT_TRABAJO = "CERTIFICADO LABORAL";
    const CERT_USSO = "CERTIFICADO USSO";
    const CERT_EVALUACION_INTEGRAL = "CERTIFICADO EVALUACIÓN INTEGRAL";
    const CERT_TRABAJO_REMITENTE = "CERTIFICADO DE TRABAJO - REMITENTE";
    const CERT_TRABAJO_SERVICIOS_PRESTADOS = "CERTIFICADO DE TRABAJO POR SERVICIOS PRESTADOS";
    const CERT_MATERIAS_DICTADAS = "CERTIFICADO DE MATERIAS DICTADAS";
    const CERT_CALIFICACIONES_CENACAD = "CERTIFICADO CALIFICACIONES EVALUACIÓN CENACAD";
    const CERT_ACTIVIDADES_POLITECNICAS = "CERTIFICADO ACTIVIDADES POLITÉCNICAS";
    const CERT_ACTIVIDADES_DESEMPENADAS_TRABAJO = "CERTIFICADO ACTIVIDADES DESEMPENADAS EN EL TRABAJO";
    const CERT_PERSONALIZADO = "CERTIFICADO PERSONALIZADO";
    const CERT_ANUAL_RUBROS = "CERTIFICADO DE INGRESOS ANUALES TOTALIZADOS POR RUBRO"
    const CERT_DECIMOS = "CERTIFICADO ACUMULACION DE DECIMOS";





    var nombre = "";
    switch (tipo) {
        case ID_CERTIFICADO_TRABAJO:
            nombre = CERT_TRABAJO;
            break;
        case ID_CERTIFICADO_CIVIL:
            nombre = CERT_TRABAJO_SERVICIOS_PRESTADOS;
            break;
        case ID_CERTIFICADO_EVALUACIONINTEGRAL:
            nombre = CERT_EVALUACION_INTEGRAL;
            break;
        default:
            break;
    }
    return nombre;
}


export const ESTADO_PENDIENTE: string = "PE";
export const ESTADO_GUARDADO: string = "G"
export const ESTADO_FIRMADO: string = "F"
export const ESTADO_ATENDIDA: string = "AT"
export const ESTADO_NO_ATENDIDA: string = "NA"
export const ESTADO_INACTIVA: string = "IN"


export function parseEstado(idtipoCertificado: number, estado: string | undefined, estadoComplementario?: string) {

    //El estadoComplementario, es el estado de la solicitud
    const ESTADO_PENDIENTE_NOMBRE: string = "ENVIADA A TH";
    const ESTADO_GUARDADO_NOMBRE: string = "PARA FIRMA DIRECCIÓN DE TH";
    const ESTADO_FIRMADO_NOMBRE: string = "FIRMADO";
    const ESTADO_ATENDIDA_NOMBRE: string = "ATENDIDA";
    const ESTADO_NO_ATENDIDA_NOMBRE: string = "SOLICITUD HA SIDO PROCESADA";
    const ESTADO_INACTVA: string = "SOLICITUD ANULADA/INACTIVA";

    var est = "";
    switch (estado) {
        case ESTADO_PENDIENTE:
            est = ESTADO_PENDIENTE_NOMBRE
            break;
        case ESTADO_GUARDADO:
            est = ESTADO_GUARDADO_NOMBRE
            break;
        case ESTADO_FIRMADO:
            est = ESTADO_FIRMADO_NOMBRE
            break;
        case ESTADO_ATENDIDA:
            est = ESTADO_ATENDIDA_NOMBRE
            break;
        case ESTADO_NO_ATENDIDA:
            est = ESTADO_NO_ATENDIDA_NOMBRE
            break;
        case ESTADO_INACTIVA:
            est = ESTADO_NO_ATENDIDA_NOMBRE
            break;
        case null:
            if (idtipoCertificado === ID_CERTIFICADO_ROLES_PAGO && estadoComplementario === ESTADO_ATENDIDA) {
                est = "NOTIFICADO"
            }
            else if (estadoComplementario !== undefined && estadoComplementario === ESTADO_NO_ATENDIDA) {
                est = "CERTIFICADO NO ATENDIDO";
            }
            else {
                est = "EN TRÁMITE POR TH"
            }
            break;
        default:
            break;
    }
    return est;
}

export async function DescargarCertificado(referencia: string) {
    var currentUser = authenticationService.currentUserValue;

    await fetch(configData.SERVER_URL + `SolicitudCertificados/DescargarCertificado/${referencia}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `KEYESPOL ${currentUser.token}`
        },
        method: "POST"
    })
        .then(response => {
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = "certificado"  //nombrearchivo
                a.click();
            });
        })
        .catch(async (error) => {
            var error_any: any = error;
            var status_code: number = handle_error(error_any);
            var mensaje_error = "Error inesperado"
            switch (status_code) {
                case 500:
                    mensaje_error = "Error inesperado. Intente más tarde"
                    break;
                case 0:
                    mensaje_error = "No ha sido posible conectarse con el servidor. Intente más tarde"
                case 401:
                    mensaje_error = "No está autorizado a realizar esta acción";
                case 409:
                    mensaje_error = await new Blob([error_any.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
                default:
                    break;
            }
            alertService.error(mensaje_error);
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
        });
}

export default function Solicitud_Certificados() {
    const [loading, setloading] = useState<boolean>(false)
    const [enviandoSolicitud, setEnviandoSolicitud] = useState<boolean>(false)
    //TABLA
    const [informacionCertificados, setinformacionCertificados] = useState<InformacionCertificados>(
        {
            contratosUsuario: [],
            tiposCertificados: [],
            informacionUsuario: { identificacion: "", nombres: "" },
            esRemunerado: false,
            estaDeComision: false,
            estaDeLicencia: false,
            estaDeLicenciaEducacion: false,
            estaDeVacaciones: false
        }
    )

    //PARA CERTIFICADOS LABORALES
    const [incluirRMU, setincluirRMU] = useState<string>("true")
    const [contratoSeleccion, setcontratoSeleccion] = useState<number>(-1)
    //PARA CERTIFICADO CIVIL
    const [incluirHonorarios, setincluirHonorarios] = useState<boolean>(true);

    const [incluirTipoContrato, setincluirTipoContrato] = useState<boolean>(false);
    const [incluirActividades, setincluirActividades] = useState<boolean>(false);


    //TIPO CERTIFICADO
    const [tipoCertificadoSeleccion, settipoCertificadoSeleccion] = useState<number>(-1)
    const [opcionesCertificado, setopcionesCertificado] = useState<{ value: string, label: string }[]>([]);
    const [certificadoSeleccionado, setcertificadoSeleccionado] = useState<TiposCertificados>()
    //DIRIGIDO
    const [dirigidoSeleccion, setdirigidoSeleccion] = useState<string>("re")
    const [opcionesDirigido, setopcionesDirigido] = useState<{ value: string, label: string }[]>([
        { label: "El portador", value: "re" },
        { label: "Un tercero", value: "ot" }
    ]);
    //CONTRATOS
    const [opcionesContrato, setopcionesContrato] = useState<{ value: string, label: string }[]>([]);

    const [clickGenerarVistaPrevia, setclickGenerarVistaPrevia] = useState<number>(-1);
    //INFORMACION CERTIFICADOS
    const [aniosDisponibles, setaniosDisponibles] = useState<number[]>([])
    const [opcionesAnios, setopcionesAnios] = useState<{ value: string, label: string }[]>([
        { label: "Todos", value: "to" },
        { label: "Seleccionar rango", value: "ran" }
    ]);
    const [anioSeleccion, setanioSeleccion] = useState<string>("")
    const [elementoAnio, setelementoAnio] = useState<HTMLElement>();
    const [loadingDatosAdicionales, setloadingDatosAdicionales] = useState<boolean>(false)

    const [anioDesde, setanioDesde] = useState<number>(-1)
    const [anioHasta, setanioHasta] = useState<number>(-1)

    const [errorAnios, seterrorAnios] = useState<string>("")
    const [nerrores, setnerrores] = useState<number>(0);

    const [listadoaniosSelect, setlistadoaniosSelect] = useState<{ value: string, label: string }[]>([]);
    const [AnioUnico, setAnioUnico] = useState<number>(-1)
    //CERTIFICADOS QUE REQUIERAN CONTRATO
    const [bloqueoSeleccionContrato, setbloqueoSeleccionContrato] = useState<boolean>(false)
    const [mensajeBloqueo, setmensajeBloqueo] = useState<HTMLElement>()
    //EVALUACION INTEGRAL - CERTIFICADOS QUE PIDEN ANIOS EN GENERAL
    const [certificadoPideAnios, setcertificadoPideAnios] = useState<boolean>(false);
    //PIDE TERMINOS ACADEMICOS
    const [certificadoPideTermnioAca, setcertificadoPideTermnioAca] = useState<boolean>(false)
    const [opcionesTermino, setopcionesTermino] = useState<{ value: string, label: string }[]>([
        { label: "Todos", value: "to" },
        { label: "PAO1 o S1", value: "PAO1" },
        { label: "PAO2 o S2", value: "PAO2" },
        { label: "PAO3 o S3", value: "PAO3" }
    ]);
    const [terminoAcademico, setterminoAcademico] = useState<string>("")

    const [certificadoMuestraListadoAnios, setcertificadoMuestraListadoAnios] = useState<boolean>(true)
    const [certificadoPrevio, setcertificadoPrevio] = useState<{ urlPDF: string, archivoPDF: File | null }>({ archivoPDF: null, urlPDF: "" })
    const [loadingVistaPrevia, setloadingVistaPrevia] = useState<boolean>(false)
    const [datosCorrectos, setdatosCorrectos] = useState<boolean>(true)
    const [datosIncorrectos, setdatosIncorrectos] = useState<boolean>(false)
    const [observaciones, setobservaciones] = useState<string>("");
    const [dirigido, setdirigido] = useState<string>("");
    const [DatosTablaSolicitudes, setDatosTablaSolicitudes] = useState<HistoriaSolicitudesCertificadoColumn[]>([])
    const [vistaPrevia, setvistaPrevia] = useState<HTMLElement>()
    const [loadingButtonDescarga, setloadingButtonDescarga] = useState<boolean>(false)
    //Boton enviar
    const [enviar, setenviar] = useState<number>(-1)
    //Modal confirmacion para anulacion
    const [idSolicitudAnular, setidSolicitudAnular] = useState<number>(-1)


    //Rango de fechas de DatePicker
    const [rangoFechasDatePicker, setrangoFechasDatePicker] = useState<{ fechaDesde: Date | undefined, fechaHasta: Date | undefined }>({
        fechaDesde: undefined,
        fechaHasta: undefined
    })

    //Roles de pago para certificado
    const [rolesPagoDeseados, setrolesPagoDeseados] = useState<number[]>([])



    const TITULO_VISTA_PREVIA = "Vista previa del certificado. (El contenido del certificado es referencial está sujeto validación por la DTH)"
    const MENSAJE_VISTA_PREVIA = "*En caso de existir alguna inconsistencia, ingrese su comentario en el casillero de observaciones*"
    const TITULO_PLANTILLA_IMAGEN = "Imagen Referencial del certificado a emitirse (El certificado definitivo será emitido por Talento Humano)"
    const ERRORES_SOLICITUDES = {
        "CONTRATO-POR-EXPIRAR": "SU CONTRATO FINALIZA DENTRO DE LOS PRÓXIMOS 30 DÍAS. DEBE SELECCIONAR EL TIPO DE CERTIFICADO PERSONALIZADO"
    }

    function ValidarExpedicion(fecha: Date) {
        // console.log(fecha)
        var fecha_consulta: Date = new Date(fecha);
        fecha_consulta.setDate(fecha_consulta.getDate() + 30);
        var anio_consulta = fecha_consulta.toUTCString().split(",")[1].split(" ")[3].trim();
        var fecha_actual = new Date();

        return fecha_consulta >= fecha_actual
    }
    function SeleccionarImagen(tipo: TiposCertificados) {
        var src = ""
        switch (tipo.idCertificado) {
            case ID_CERTIFICADO_CIVIL:
                src = certificadocontratoscivilespdf
                break;
            case ID_CERTIFICADO_CALIFICACIONES_CENACAD:
                src = certificadocenacadpdf
                break;
            case ID_CERTIFICADO_MATERIAS_DICTADAS:
                src = certificadomateriasdictadaspdf
                break;
            case ID_CERTIFICADO_ACTIVIDADES_POLITECNICAS:
                src = certificadoactividadespolitecnicaspdf
                break;
            case ID_CERTIFICADO_ACTIVIDADES_DESEMPENADAS_TRABAJO:
                src = certificadoactividadestrabajopdf
                break;
            case ID_CERTIFICADO_LABORAL_DETALLADO:
                src = certificadolaboraldetalladopdf
                break;
            case ID_CERTIFICADO_ACUMULACION_DECIMOS:
                src = certificadoacumulaciondecimospdf
                break;
            case ID_CERTIFICADO_INGRESOS_ANUALES:
                src = certificadoingresosanualespdf
                break;
            default:
                break;
        }

        return src;
    }



    const ObtenerInformacionCertificados = async (datosUsuario: UserData) => {
        try {
            const respuesta = await axios.get(configData.SERVER_URL + "SolicitudCertificados/InformacionSolicitudCertificados/", {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario?.token}`,

                }
            });

            const info: InformacionCertificados = respuesta.data;
            setinformacionCertificados(info);

        } catch (error) {
            var error_any: any = error;
            var number = handle_error(error_any);
            alertService.error("Ha ocurrido un inconveniente")
        }


    }





    const ObtenerInformacionSolicitudes = async (datosUsuario: UserData) => {
        try {
            const respuesta = await axios.get(configData.SERVER_URL + "SolicitudCertificados/SolicitudesEmitidas", {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario?.token}`,

                }



            });
            var solicitudes: SolicitudCertificado[] = respuesta.data;
            var datostabla: HistoriaSolicitudesCertificadoColumn[] = [];
            solicitudes.map((sol) => {
                datostabla.push({
                    tip: sol.nombreCertificado,

                    fecs: sol.fechasolicitud,
                    obs: sol.observaciones,
                    est: parseEstado(sol.idcertificadotipo, sol.estadosolicitud),
                    estc: parseEstado(sol.idcertificadotipo, sol.estadoCertificado, sol.estadosolicitud),
                    cert: {
                        referencia: sol.referenciaCertificado,
                        estadocertificado: sol.estadoCertificado,
                        certificadoVigente: sol.fechaHora ? ValidarExpedicion(sol.fechaHora) : false,
                        certificadoAutomatizado: sol.automatizado,
                        nombreTipoCertificado: sol.nombreCertificado,
                        estadoSolicitud: sol.estadosolicitud,
                        idTipoCertificado: sol.idcertificadotipo,
                        analistaEmitio: "",
                        fechaEmisionCertificado: "",
                        fechaSolicitudFormato: ""
                    },
                    anularSolicitud: {
                        idSolicitud: sol.idsolcertth,
                        estadosolicitud: sol.estadosolicitud
                    },
                    dir: sol.dirigido
                })
            })
            setDatosTablaSolicitudes(datostabla);

        } catch (error) {
            var error_any: any = error;
            var status = handle_error(error_any);
            switch (status) {
                case 204:
                    alertService.clear("No tiene solicitudes creadas hasta el momento")
                    break;
                case 500:
                    alertService.error("Ha ocurrido un inconveniente al tratar de obtener las solicitudes realizadas")
                    break;
            }
        }
    }

    async function AuxiliarObtenerInformacionSolicitudes() {

        var datosUsuario: UserData = authenticationService.currentUserValue;

        var resultado: ResponseRequest = {
            status: -1
        }

        try {
            const respuesta = await axios.get(configData.SERVER_URL + "SolicitudCertificados/SolicitudesEmitidas", {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario.token}`,

                }
            });
            var solicitudes: SolicitudCertificado[] = respuesta.data;
            var datostabla: HistoriaSolicitudesCertificadoColumn[] = [];
            if (solicitudes.length > 0) {
                solicitudes.map((sol) => {
                    datostabla.push({
                        tip: sol.nombreCertificado,

                        fecs: sol.fechasolicitud,
                        obs: sol.observaciones,
                        est: parseEstado(sol.idcertificadotipo, sol.estadosolicitud),
                        estc: parseEstado(sol.idcertificadotipo, sol.estadoCertificado, sol.estadosolicitud),
                        cert: {
                            referencia: sol.referenciaCertificado,
                            estadocertificado: sol.estadoCertificado,
                            certificadoVigente: sol.fechaHora ? ValidarExpedicion(sol.fechaHora) : false,
                            certificadoAutomatizado: sol.automatizado,
                            nombreTipoCertificado: sol.nombreCertificado,
                            estadoSolicitud: sol.estadosolicitud,
                            idTipoCertificado: sol.idcertificadotipo,
                            analistaEmitio: "",
                            fechaEmisionCertificado: "",
                            fechaSolicitudFormato: ""
                        },
                        anularSolicitud: {
                            idSolicitud: sol.idsolcertth,
                            estadosolicitud: sol.estadosolicitud
                        },
                        dir: sol.dirigido
                    })
                })
            }
            resultado.status = respuesta.status;
            resultado.dataResponse = datostabla;

        } catch (error) {
            var errorMessage = "Ha ocurrido un inconveniente al tratar de obtener las solicitudes realizadas";
            if (axios.isAxiosError(error)) {
                if (error.response) {
                    switch (error.response.status) {
                        case 204:
                            errorMessage = "No tiene solicitudes creadas hasta el momento"
                            break;
                        case 409:
                            errorMessage = error.response.data
                            break;
                        default:
                            break;
                    }
                }
            }
            resultado.errorMessage = errorMessage;
        }

        return resultado;
    }




    async function EnviarSolicitud(RequestDatos: RequestSolicitudCertificado, datosIncorrectos: boolean) {
        setEnviandoSolicitud(true)
        var errorMessage = ""
        var datosUsuario = authenticationService.currentUserValue;
        if (RequestDatos.dirigido && RequestDatos.dirigido === "") {
            RequestDatos.dirigido = undefined
        }

        try {

            const respuesta = await axios.post(configData.SERVER_URL + "SolicitudCertificados/SolicitarCertificado", RequestDatos,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `KEYESPOL ${datosUsuario?.token}`,

                    },
                });
            alertService.success("Su solicitud ha sido enviada con éxito");
            var solicitudCreada: SolicitudCertificado = respuesta.data;

            // var solicitudCreadaParaTabla: HistoriaSolicitudesCertificadoColumn = {
            //     fecs: solicitudCreada.fechasolicitud,
            //     tip: solicitudCreada.nombreCertificado,
            //     obs: solicitudCreada.observaciones,
            //     est: parseEstado(solicitudCreada.estadosolicitud),
            //     estc: solicitudCreada.estadoCertificado ? parseEstado(solicitudCreada.estadoCertificado) : "EN TRÁMITE POR TH",
            //     cert: {
            //         referencia: solicitudCreada.referenciaCertificado,
            //         estadocertificado: solicitudCreada.estadoCertificado,
            //         certificadoVigente: solicitudCreada.fechaHora ? ValidarExpedicion(solicitudCreada.fechaHora) : false,
            //         certificadoAutomatizado: solicitudCreada.automatizado,
            //         nombreTipoCertificado: solicitudCreada.nombreCertificado,
            //     },
            //     anularSolicitud: {
            //         idSolicitud: solicitudCreada.idsolcertth,
            //         estadosolicitud: solicitudCreada.estadosolicitud
            //     },
            //     dir: solicitudCreada.dirigido
            // };




            // setDatosTablaSolicitudes([...DatosTablaSolicitudes, solicitudCreadaParaTabla])
            var respuestaLlamada = await AuxiliarObtenerInformacionSolicitudes();
            if (respuestaLlamada.status === 200 || respuestaLlamada.status === 204) {
                setDatosTablaSolicitudes(respuestaLlamada.dataResponse);
                setidSolicitudAnular(-1)

            }
            else {
                alertService.error(respuestaLlamada.errorMessage);
            }

            window.scrollTo({
                top: 0,
                behavior: "auto"
            });

        } catch (error) {
            var error_any: any = error;
            var status_code: number = handle_error(error_any);
            switch (status_code) {
                case -1:
                    alertService.error("No se ha podido establecer contacto con el servidor");
                    break;
                case 500:
                    alertService.error("Ha ocurrido un error inesperado");
                    break;
                case 409:
                    if (error_any.response.data === ERRORES_SOLICITUDES["CONTRATO-POR-EXPIRAR"]) {
                        errorMessage = error_any.response.data;
                    }
                    alertService.error(error_any.response.data)
                    break;
                default:
                    alertService.error("Ha ocurrido un error desconocido");
                    break;
            }
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });

        }
        setEnviandoSolicitud(false)
        if (errorMessage === ERRORES_SOLICITUDES["CONTRATO-POR-EXPIRAR"]) {
            ReiniciarForm(ID_CERTIFICADO_PERSONALIZADO);
        }
        else {
            ReiniciarForm();
        }

        return
    }

    useEffect(() => {

        setloading(true)
        var datosUsuario = authenticationService.currentUserValue;
        if (datosUsuario) {
            ObtenerInformacionSolicitudes(datosUsuario);
            ObtenerInformacionCertificados(datosUsuario);
        }

    }, [])

    useEffect(() => {
        const { tiposCertificados, contratosUsuario } = informacionCertificados;
        if (contratosUsuario.length !== 0) {

            var opciones: { value: string, label: string }[] = [];

            contratosUsuario.map((contr) => {
                if (certificadoSeleccionado !== undefined && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_TRABAJO) {
                    if (contr.idRegimen !== ID_REGIMEN_CONTRATO_CIVIL) {
                        opciones.push({
                            value: contr.idContrato.toString(),
                            label: contr.regimen + " - " + contr.cargo

                        });
                    }
                }
                else if (certificadoSeleccionado !== undefined && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_CIVIL) {
                    if (contr.idRegimen === ID_REGIMEN_CONTRATO_CIVIL) {
                        opciones.push({
                            value: contr.idContrato.toString(),
                            label: contr.regimen + " - " + contr.cargo

                        });
                    }
                }
                else {
                    opciones.push({
                        value: contr.idContrato.toString(),
                        label: contr.regimen + " - " + contr.cargo

                    });
                }

            })

            setopcionesContrato(opciones);

        }

        if (tiposCertificados.length !== 0) {
            var opcionestipocer: { value: string, label: string }[] = [];
            {
                tiposCertificados.map((cert) => {
                    opcionestipocer.push({
                        label: cert.descripcion,
                        value: cert.idCertificado.toString()
                    })
                })
            }
            setopcionesCertificado(opcionestipocer);
            setloading(false)


        }


    }, [informacionCertificados.tiposCertificados, informacionCertificados.contratosUsuario, certificadoSeleccionado])


    useEffect(() => {

        const ObtenerCertificado = async (idContrato: number, idTipoCertificado: number, currentUser: UserData, dirigido: string, informacion_adicional?: any) => {
            setloadingVistaPrevia(true)
            var certificadourl = ""
            var datosCertificado: DatosCertificadoTrabajo | DatosCertificadoEvaluacionIntegral | DatosCertificadoConAnios | ParametrosNewCertificado | undefined = undefined
            var ulrrequest = `SolicitudCertificados/`;
            switch (idTipoCertificado) {
                // case 1:
                //     certificadourl = `InformacionSolicitudCertificados/CertificadoTrabajo/${idContrato}`
                //     datosCertificado = informacion_adicional
                //     break;
                case ID_CERTIFICADO_TRABAJO:
                    certificadourl = `VistaPreviaCertificado/CertificadoTrabajo`
                    datosCertificado = { Dirigido: dirigido, VistaPrevia: true, Contrato: informacion_adicional }
                    break;
                case ID_CERTIFICADO_EVALUACIONINTEGRAL:
                    certificadourl = `VistaPreviaCertificado/CertificadoEvaluacionIntegral`
                    datosCertificado = informacion_adicional
                    break;
                case ID_CERTIFICADO_CALIFICACIONES_CENACAD:
                    certificadourl = `VistaPreviaCertificado/CertificadoCalificacionesCenacad`
                    datosCertificado = informacion_adicional
                    break;
                case ID_CERTIFICADO_MATERIAS_DICTADAS:
                    certificadourl = `VistaPreviaCertificado/CertificadoMateriasDictadas`
                    datosCertificado = informacion_adicional
                    break;
                case ID_CERTIFICADO_CONTRATACIONES_CIVILES:
                    certificadourl = `VistaPreviaCertificado/CertificadoContratacionesCiviles`
                    datosCertificado = { Dirigido: dirigido, VistaPrevia: true, OpcionesContratacionesCiviles: informacion_adicional }
                    break;


                default:
                    break;
            }
            ulrrequest += certificadourl;


            if (!datosCertificado) {
                alertService.error("No ha sido posible generar una vista previa")
                return
            }

            await fetch(configData.SERVER_URL + ulrrequest, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${currentUser?.token}`,

                },
                body: JSON.stringify(datosCertificado)
            })
                .then(response => {

                    if (response.ok) {
                        response.blob()
                            .then(blob => {
                                let url = window.URL.createObjectURL(blob);
                                var file_object = new File([blob], "certificado");
                                setcertificadoPrevio({
                                    urlPDF: url,
                                    archivoPDF: file_object
                                })

                            });

                    } else {

                        response.text()
                            .then(e => {
                                alertService.error(e)

                            });
                    }

                })

                .catch((error) => {
                    var error_any: any = error;
                    var status_code: number = handle_error(error_any);
                    switch (status_code) {
                        case 0:
                            alertService.error("No se ha podido establecer contacto con el servidor");
                            break;
                        case 500:
                            alertService.error("Ha ocurrido un error inesperado");
                            break;
                        default:
                            alertService.error("Ha ocurrido un error desconocido");
                            break;
                    }
                    window.scrollTo({
                        top: 0,
                        behavior: "auto"
                    });
                });
            setloadingVistaPrevia(false)
        }
        var datosUsuario = authenticationService.currentUserValue;

        if (clickGenerarVistaPrevia > -1 && contratoSeleccion !== -1 && tipoCertificadoSeleccion !== -1) {

            const informacionCertificadoLaboral: ParametrosContratoLaboral = {
                IdContrato: contratoSeleccion,
                IdRegimenLaboral: informacionCertificados.contratosUsuario.find(c => c.idContrato == contratoSeleccion)?.idRegimen ?? -1,
                IncluirSueldo: incluirRMU === "true",
                // dirigido,
                // incluirSueldo: incluirRMU === "true"


            }

            ObtenerCertificado(0, tipoCertificadoSeleccion, datosUsuario, dirigido, informacionCertificadoLaboral)



            // if (dirigidoSeleccion === "re") {
            //     informacion_certificados_conContrato.dirigido = ""
            //     // ObtenerCertificado(contratoSeleccion, tipoCertificadoSeleccion, datosUsuario, "", informacion_certificados_conContrato)
            // }
            // else if (dirigidoSeleccion === "ot" && dirigido !== "") {
            //     // ObtenerCertificado(contratoSeleccion, tipoCertificadoSeleccion, datosUsuario, dirigido, informacion_certificados_conContrato)

            // }
        }
        else if (clickGenerarVistaPrevia > -1 && certificadoSeleccionado && !certificadoSeleccionado.requierecontrato) {
            var certificadorequiereanios: boolean = IDS_certificados_piden_anios.findIndex(value => value == certificadoSeleccionado.idCertificado) != -1
            var certificadorrequiereterminos: boolean = IDS_certificados_piden_terminos.findIndex(value => value == certificadoSeleccionado.idCertificado) != -1

            if (certificadorequiereanios && IDS_certificados_muestran_listado_anios.includes(certificadoSeleccionado.idCertificado)) {

                if (certificadoSeleccionado.idCertificado === ID_CERTIFICADO_CONTRATACIONES_CIVILES) {

                    const informacionExtra: OpcionesContratacionesCiviles = {
                        IncluirHonorarios: incluirHonorarios,
                        IncluirTipoContrato: incluirTipoContrato,
                        IncluirActividades: incluirActividades,
                        AnioInicio: anioDesde.toString(),
                        AnioFin: anioHasta.toString()
                    };

                    ObtenerCertificado(0, tipoCertificadoSeleccion, datosUsuario, dirigido, informacionExtra)
                }
                else {
                    var informacion_adicional: DatosCertificadoEvaluacionIntegral | DatosCertificadoConAnios = {
                        dirigido,
                        fechaDesde: AnioUnico,
                        todasFechas: false
                    };

                    switch (certificadoSeleccionado.idCertificado) {
                        case ID_CERTIFICADO_CALIFICACIONES_CENACAD:

                            informacion_adicional = {
                                ...informacion_adicional,
                                dirigido,
                                todasFechas: anioSeleccion === "to",
                                fechaDesde: anioSeleccion !== "to" ? anioDesde : undefined,
                                fechaHasta: anioSeleccion !== "to" ? anioHasta : undefined,
                            }
                            break;
                        case ID_CERTIFICADO_MATERIAS_DICTADAS:

                            informacion_adicional = {
                                ...informacion_adicional,
                                dirigido,
                                todasFechas: anioSeleccion === "to",
                                fechaDesde: anioSeleccion !== "to" ? anioDesde : undefined,
                                fechaHasta: anioSeleccion !== "to" ? anioHasta : undefined,
                            }
                            break;

                        default:
                            break;
                    }

                    ObtenerCertificado(0, tipoCertificadoSeleccion, datosUsuario, dirigido, informacion_adicional)
                }


            }
            else {
                ;
                // const informacionExtra: OpcionesContratacionesCiviles = {
                //     IncluirHonorarios: incluirHonorarios,
                //     IncluirTipoContrato: incluirTipoContrato,
                //     IncluirActividades: incluirActividades
                // };
                // switch (certificadoSeleccionado.idCertificado) {
                //     case ID_CERTIFICADO_CONTRATACIONES_CIVILES:

                // }
                // ObtenerCertificado(0, tipoCertificadoSeleccion, datosUsuario, dirigido, informacionExtra)

            }


        }

    },
        // [contratoSeleccion, dirigidoSeleccion, dirigido])
        [clickGenerarVistaPrevia, informacionCertificados])

    useEffect(() => {


        if (certificadoPrevio.urlPDF !== "" && !loadingVistaPrevia) {
            var vistaPreviaCertificadoConDatos: any = <div className="" >
                <div className="tituloVistaPrevia">{TITULO_VISTA_PREVIA}</div>
                <div className="advertenciaVistaPrevia">{MENSAJE_VISTA_PREVIA}</div>
                <PDFViewer url={certificadoPrevio.urlPDF} heightValue={"700px"} />
            </div>


            setvistaPrevia(vistaPreviaCertificadoConDatos);

        }
    }, [certificadoPrevio.urlPDF, loadingVistaPrevia])


    function handleSelectChange(value: string, name: string) {
        setcontratoSeleccion(+value)
    }
    function handleSelectChangeDirigido(value: string, name: string) {
        setdirigidoSeleccion(value)
            if (value === "re") {
                setdirigido("")
            }
        
        

    }
    function handleSelectChangeTiposCertificados(value: string, name: string) {
        settipoCertificadoSeleccion(+value)


    }
    function handleSelectChangeAnio(value: string, name: string) {
        setanioSeleccion(value)


    }
    function handleSelectChangeRMU(value: string, name: string) {
        setincluirRMU(value)
    }



    async function HandleDescargarCertificado(referencia: string) {
        setloadingButtonDescarga(true)
        await DescargarCertificado(referencia)
        setloadingButtonDescarga(false)
    }

    function ReiniciarForm(idTipoCertificadoSeleccionado: number = -1) {
        setanioDesde(-1)
        setanioHasta(-1)
        setAnioUnico(-1)
        setnerrores(0)
        setelementoAnio(undefined)
        setaniosDisponibles([])
        setlistadoaniosSelect([])
        setvistaPrevia(undefined)
        setcontratoSeleccion(-1)
        setcertificadoSeleccionado(undefined)
        settipoCertificadoSeleccion(idTipoCertificadoSeleccionado)
        setcertificadoPideAnios(false)
        setcertificadoPideTermnioAca(false)
        seterrorAnios("")
        setobservaciones("")
        setanioSeleccion("")
        setdirigidoSeleccion("")
        setdirigido("")
        setterminoAcademico("")
        setmensajeBloqueo(undefined)
        setbloqueoSeleccionContrato(false)
        setrangoFechasDatePicker({ fechaDesde: undefined, fechaHasta: undefined })
        setrolesPagoDeseados([])
    }

    function LimpiarValoresCambiarTipo() {
        setanioDesde(-1)
        setanioHasta(-1)
        setAnioUnico(-1)
        setnerrores(0)
        setcontratoSeleccion(-1)

        setelementoAnio(undefined)
        setaniosDisponibles([])
        setlistadoaniosSelect([])
        setvistaPrevia(undefined)
        setcertificadoSeleccionado(undefined)
        setcertificadoPideAnios(false)
        setcertificadoPideTermnioAca(false)
        setdirigido("")
        setdirigidoSeleccion("re")
        setterminoAcademico("")
        setanioSeleccion("")
        seterrorAnios("")
        setobservaciones("")
        setmensajeBloqueo(undefined)
        setbloqueoSeleccionContrato(false)
        setrangoFechasDatePicker({ fechaDesde: undefined, fechaHasta: undefined })
        setrolesPagoDeseados([])

    }

    useEffect(() => {
        if (tipoCertificadoSeleccion !== -1) {
            LimpiarValoresCambiarTipo()
            //Se busca el tipo de certificado elegido en la respuesta almacenada
            const { tiposCertificados } = informacionCertificados;
            var tipo_certificado_elegido = tiposCertificados.find((value) => value.idCertificado == tipoCertificadoSeleccion)
            if (tipo_certificado_elegido) {
                setcertificadoSeleccionado(tipo_certificado_elegido);

            }

        }
    }, [tipoCertificadoSeleccion])



    useEffect(() => {

        function GenerarElementoVistaModelo(link_imagen: string): any {
            setloadingVistaPrevia(true)
            var elementoPlantilla: any;

            // if (link_imagen) {
            // elementoPlantilla = <div className="" >
            //     <div className="tituloVistaPrevia">{TITULO_PLANTILLA_IMAGEN}</div>
            //     <PDFViewer url={link_imagen} heightValue={"700px"} />
            // </div>

            //     )

            // }
            // else {
            //     elementoPlantilla = <div></div>
            // }

            elementoPlantilla = (
                <React.Fragment>
                    <h5 className="text-justify">La visualización del certificado se encuentra en construcción.</h5>
                    <h5 className="text-justify">Complete los datos del formulario y envíe la solicitud a TH, para la elaboración del certificado.
                    </h5>
                </React.Fragment>
            )

            setloadingVistaPrevia(false)
            return elementoPlantilla;
        }
        function AuxiliarCertificadosSinVistaPrevia(certificadoSeleccionado: TiposCertificados) {
            var link_imagen = SeleccionarImagen(certificadoSeleccionado);
            var PlantilaReferencialVistaPrevia: any;
            if (certificadoSeleccionado.idCertificado === ID_CERTIFICADO_ROLES_PAGO) {
                PlantilaReferencialVistaPrevia = undefined;
            }
            else {
                PlantilaReferencialVistaPrevia = GenerarElementoVistaModelo(link_imagen)
            }

            setvistaPrevia(PlantilaReferencialVistaPrevia);

            var certificadorequiereanios: boolean = IDS_certificados_piden_anios.findIndex(value => value == certificadoSeleccionado.idCertificado) != -1
            setcertificadoPideAnios(certificadorequiereanios)
            var certificadorrequiereterminos: boolean = IDS_certificados_piden_terminos.findIndex(value => value == certificadoSeleccionado.idCertificado) != -1
            setcertificadoPideTermnioAca(certificadorrequiereterminos)
        }
        function AuxiliarCertificadosConVistaPrevia(certificadoSeleccionado: TiposCertificados) {
            var certificadorequiereanios: boolean = IDS_certificados_piden_anios.findIndex(value => value == certificadoSeleccionado.idCertificado) != -1
            setcertificadoPideAnios(certificadorequiereanios)
            var certificadorrequiereterminos: boolean = IDS_certificados_piden_terminos.findIndex(value => value == certificadoSeleccionado.idCertificado) != -1
            setcertificadoPideTermnioAca(certificadorrequiereterminos)
        }
        function AuxiliarValidarCertificadoRestriccion() {
            var mensaje: any = <small></small>

            var LicenciaSinRMU: boolean = informacionCertificados.estaDeLicencia && !informacionCertificados.esRemunerado;
            var LicenciadeEstudios: boolean = informacionCertificados.estaDeLicenciaEducacion;
            var ComisionSinRMU: boolean = informacionCertificados.estaDeComision && !informacionCertificados.esRemunerado;
            var seleccionaCertificadoConContrato: boolean = certificadoSeleccionado !== undefined && informacionCertificados !== undefined && (certificadoSeleccionado?.idCertificado === ID_CERTIFICADO_LABORAL_DETALLADO || certificadoSeleccionado?.idCertificado === ID_CERTIFICADO_TRABAJO);
            var bloqueoLicencia: boolean = LicenciaSinRMU && seleccionaCertificadoConContrato;
            var bloqueoLicenciaEstudio: boolean = LicenciadeEstudios && seleccionaCertificadoConContrato;
            var bloqueoComisionSinRMU: boolean = ComisionSinRMU && seleccionaCertificadoConContrato;
            var bloqueo = bloqueoLicencia || bloqueoLicenciaEstudio || bloqueoComisionSinRMU

            if (bloqueo) {
                mensaje = <small className="errorFormat">No puede seleccionar el certificado, por favor , solicitar un certificado personalizado</small>
                setbloqueoSeleccionContrato(true)
            }
            setmensajeBloqueo(mensaje)
            return bloqueo
        }

        var bloquearSeleccion = AuxiliarValidarCertificadoRestriccion();

        if (certificadoSeleccionado && !bloquearSeleccion) {




            if (certificadoSeleccionado.requierecontrato && opcionesContrato.length === 1) {
                setcontratoSeleccion(+opcionesContrato[0].value);
            }




            if (certificadoSeleccionado.requierecontrato && contratoSeleccion !== -1) {
                if (!certificadoSeleccionado.tienevistaprevia) {
                    AuxiliarCertificadosSinVistaPrevia(certificadoSeleccionado)
                }
            }
            else if (!certificadoSeleccionado.requierecontrato) {
                if (!certificadoSeleccionado.tienevistaprevia) {
                    AuxiliarCertificadosSinVistaPrevia(certificadoSeleccionado)
                }
                else {
                    AuxiliarCertificadosConVistaPrevia(certificadoSeleccionado)
                }
            }
        }


    }, [certificadoSeleccionado, contratoSeleccion, opcionesContrato, informacionCertificados])





    async function ObtenerInfoParaCertificado(idTipoCertificado: number) {
        setloadingDatosAdicionales(true)
        try {
            var datosUsuario: UserData = authenticationService.currentUserValue;


            var certificadourl = ""
            var ulrrequest = `SolicitudCertificados/InformacionSolicitudCertificados/`;
            switch (idTipoCertificado) {

                case ID_CERTIFICADO_EVALUACIONINTEGRAL:
                    certificadourl = `CertificadoEvaluacionIntegral`
                    break;
                case ID_CERTIFICADO_CALIFICACIONES_CENACAD:
                    certificadourl = `CertificadoCalificacionesCenacad`
                    break;
                case ID_CERTIFICADO_MATERIAS_DICTADAS:
                    certificadourl = `CertificadoMateriasDictadas`
                    break;
                case ID_CERTIFICADO_CONTRATACIONES_CIVILES:
                    certificadourl = `CertificadoContratacionesCiviles`
                    break;
                default:
                    break;
            }
            ulrrequest += certificadourl;

            const respuesta = await axios.get(configData.SERVER_URL + ulrrequest, {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario.token}`,

                }
            });

            const info_anios: number[] = respuesta.data
            setaniosDisponibles(info_anios);


        } catch (error) {
            var error_any: any = error;
            var number = handle_error(error_any);
            alertService.error("Ha ocurrido un inconveniente al intentar obtener informacion para el certificado seleccionado")
            //VALIDAR POR SI NO HAY INFORMACION DE ANIOS INDICAR QUE ESTA VACIA LA RESPUESTA
        }
        setloadingDatosAdicionales(false)

    }

    useEffect(() => {
        if (certificadoPideAnios && certificadoSeleccionado) {

            const { idCertificado } = certificadoSeleccionado

            var tienelistadoAnios: boolean = IDS_certificados_muestran_listado_anios.findIndex(value => value == idCertificado) != -1
            if (tienelistadoAnios) {
                ObtenerInfoParaCertificado(idCertificado);
            }
            else {
                setcertificadoMuestraListadoAnios(false)
            }


        }
    }, [certificadoPideAnios, certificadoSeleccionado])


    function AuxiliarAsignarAnios() {
        var anioslista: { value: string, label: string }[] = []
        aniosDisponibles.map((valor, index) => {
            anioslista.push({
                label: valor.toString(),
                value: valor.toString()
            })
        })



        setlistadoaniosSelect(anioslista);
    }

    useEffect(() => {
        if (aniosDisponibles && aniosDisponibles.length !== 0) {
            // var texto: string = ""
            // aniosDisponibles.map((value, index) => {
            //     texto += value + "\n"
            // })

            // var elemento: any = (
            //     <textarea
            //         cols={50}
            //         rows={5}
            //         maxLength={300}
            //         defaultValue={texto}
            //     />)
            // setelementoAnio(elemento)


            if (certificadoSeleccionado) {
                const { idCertificado } = certificadoSeleccionado
                var esEvaluacionIntegral: boolean = idCertificado === ID_CERTIFICADO_EVALUACIONINTEGRAL;
                var esCertificadoPideAniosSeleccion: boolean = IDS_certificados_muestran_listado_anios.includes(idCertificado);
                var certificadoTieneAniosDisponibles = aniosDisponibles && aniosDisponibles.length !== 0

                if (esCertificadoPideAniosSeleccion && certificadoTieneAniosDisponibles) {
                    AuxiliarAsignarAnios()

                    //En los certificados de contratacion civil, el anio fin, se deja fijo.
                    if (idCertificado == ID_CERTIFICADO_CONTRATACIONES_CIVILES) {
                        const maximoAnioFin = Math.max(...aniosDisponibles);
                        setanioHasta(maximoAnioFin);
                    }

                }



            }
        }
    }, [aniosDisponibles, certificadoSeleccionado])


    useEffect(() => {
        var certificadoTieneAniosDisponibles = aniosDisponibles && aniosDisponibles.length !== 0
        if (certificadoTieneAniosDisponibles && anioSeleccion === "ran") {
            AuxiliarAsignarAnios()
        }
    }, [anioSeleccion])

    useEffect(() => {
        if (enviar > -1) {


            var requestInfoAnios: DatosCertificadosAniosRequest | undefined = undefined;

            if (anioSeleccion === "ran" && anioDesde && anioHasta) {
                requestInfoAnios = {
                    fechaDesde: anioDesde,
                    fechaHasta: anioHasta,
                    todasFechas: false
                }
            }

            else if (anioSeleccion === "to") {
                requestInfoAnios = {
                    todasFechas: true
                }
            }
            else if (AnioUnico > 0) {
                requestInfoAnios = {
                    fechaDesde: AnioUnico,
                    todasFechas: false
                }
            }

            if (requestInfoAnios && terminoAcademico !== "") {
                requestInfoAnios.terminos = terminoAcademico;
            }

            var requestInformacionSolicitud: ParametrosNewCertificado | undefined = undefined;

            var requestInfoRoles: DatosCertificadoRolesDePago | undefined = undefined;




            switch (certificadoSeleccionado?.idCertificado) {
                case ID_CERTIFICADO_TRABAJO:
                    requestInformacionSolicitud = {
                        Dirigido: dirigido,
                        Contrato: {
                            IdContrato: contratoSeleccion,
                            IdRegimenLaboral: informacionCertificados.contratosUsuario.find(c => c.idContrato == contratoSeleccion)?.idRegimen ?? -1,
                            IncluirSueldo: incluirRMU === "true",
                        },
                        VistaPrevia: false
                    }
                    break;

                case ID_CERTIFICADO_ROLES_PAGO:

                    if (rangoFechasDatePicker.fechaDesde !== undefined && rangoFechasDatePicker.fechaHasta !== undefined) {
                        requestInfoRoles = {
                            rolesDeseados: rolesPagoDeseados,
                            fechaDesde: PruebaSolucion2(rangoFechasDatePicker.fechaDesde),
                            fechaHasta: PruebaSolucion2(rangoFechasDatePicker.fechaHasta)
                        }
                    }

                    break;
                case ID_CERTIFICADO_CONTRATACIONES_CIVILES:
                    requestInformacionSolicitud = {
                        Dirigido: dirigido,
                        OpcionesContratacionesCiviles: {
                            IncluirHonorarios: incluirHonorarios,
                            IncluirTipoContrato: incluirTipoContrato,
                            IncluirActividades: incluirActividades,
                            AnioInicio: anioDesde.toString(),
                            AnioFin: anioHasta.toString()
                        },
                        VistaPrevia: false
                    }
                    break;
                default:
                    break;
            }

            EnviarSolicitud({
                idCertificadoTipo: tipoCertificadoSeleccion,
                dirigido,
                idContrato: contratoSeleccion,
                observaciones,
                datosCertificadoAnios: requestInfoAnios,
                datosCertificadoLaboral: requestInformacionSolicitud,
                datosCertificadoRoles: requestInfoRoles
            },
                datosIncorrectos)
        }
    }, [enviar])



    function handleChangeanio(anio: number, nombre: string, nerrores: number = 0) {

        if ((nombre === "hasta" && anio < anioDesde) || (nombre === "desde" && anio > anioHasta)) {
            seterrorAnios("El año fin debe ser igual o mayor al año inicio ")
        }
        else {
            seterrorAnios("")
        }
        if (nombre === "hasta") {
            setanioHasta(anio)

        }
        else if (nombre === "desde") {
            setanioDesde(anio)
        }

        setnerrores(nerrores)
    }


    async function HandleAnularCertificado(idSolicitud: number) {

        var datos: UserData = authenticationService.currentUserValue;
        const URL_ANULAR_CERTIFICADO = `${configData.SERVER_URL}SolicitudCertificados/AnularSolicitudes/${idSolicitud}`
        try {
            const respuesta = await axios.delete(URL_ANULAR_CERTIFICADO,
                {
                    headers: authHeaderWithUserData(authenticationService.currentUserValue)
                })

            var idSolicitudEliminada: number = respuesta.data;
            alertService.success("Se ha anulado la solicitud de certificado con éxito.")
            return 1;
        } catch (error) {
            var mensaje = "No se ha podido establecer contacto con el servidor.";
            if (axios.isAxiosError(error)) {
                if (error.response) {
                    switch (error.response.status) {
                        case 409:
                            mensaje = error.response.data
                            break;
                        default:
                            mensaje = "Ha ocurrido un inconveniente. Intente más tarde."
                            break;
                    }
                }
            }
            alertService.error(mensaje)
            return -1;
        }


    }


    const AnulacionCertificado = useCallback(
        async () => {
            var status_request = await HandleAnularCertificado(idSolicitudAnular);
            return status_request;
        },
        [idSolicitudAnular])

    const CerrarModalConfirmacionYActualizar = useCallback(
        async () => {
            var datosUsuario = authenticationService.currentUserValue;
            var respuestaLlamada = await AuxiliarObtenerInformacionSolicitudes();
            if (respuestaLlamada.status === 200 || respuestaLlamada.status === 204) {
                setDatosTablaSolicitudes(respuestaLlamada.dataResponse);
                setidSolicitudAnular(-1)

            }
            else {
                alertService.error(respuestaLlamada.errorMessage);
            }
        },
        [idSolicitudAnular, DatosTablaSolicitudes])


    const SelectAniosCertificadoCivil = useMemo(() => {


        if (certificadoSeleccionado !== undefined && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_CONTRATACIONES_CIVILES && listadoaniosSelect.length > 0) {



            var listadoParaInicioCiviles = [...listadoaniosSelect];

            //if (informacionCertificados && informacionCertificados.contratosUsuario && informacionCertificados.contratosUsuario.length > 0) {



            //    const contratosFiltrados = informacionCertificados.contratosUsuario.find(c => c.idRegimen == ID_REGIMEN_CONTRATO_CIVIL)
            //    const tieneContratosCivilesVigentes = contratosFiltrados !== undefined;



            //}

            return (
                <React.Fragment>
                    <Row>
                        <Col md={12}>
                            <Label for="aniosinicioselect"> Seleccione el rango para su certificado </Label>
                        </Col>
                    </Row>
                    <Row form>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="aniosinicioselect"> Año Inicio*</Label>
                                <SelectItem
                                    options={listadoParaInicioCiviles}
                                    value={anioDesde.toString()}
                                    onChange={(anio: string) => { handleChangeanio(+anio, "desde") }}
                                    placeHolder=""
                                    name="aniosinicioselect"
                                    id="aniosinicioselect"
                                    icon="fa-caret-right"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="aniosfinselect"> Año Fin*</Label>
                                <SelectItem
                                    options={listadoaniosSelect}
                                    value={anioHasta.toString()}
                                    disabled={true}
                                    onChange={(anio: string) => { handleChangeanio(+anio, "hasta") }}
                                    placeHolder=""
                                    name="aniosfinselect"
                                    id="aniosfinselect"
                                    icon="fa-caret-right"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </React.Fragment>

            )
        }
        return undefined;
    }, [certificadoSeleccionado, listadoaniosSelect, anioDesde, anioHasta, informacionCertificados.contratosUsuario])


    const SelectTiposroles = useMemo(() => {

        var opcionesSelectTipoRoles: SelectCombo[] = rolesPagoKeys.map((keys, index) => {
            var name = ParseNombreEnumRolesPago(keys);
            return { label: name, value: rolesPagoValue[index].toString() }
        });

        function onChangeSelectRoles(value: Array<SelectCombo>) {
            var rolesDeseados: Array<number> = []
            if (value != null && value.length > 0) {
                rolesDeseados = value.map((v, i) => {
                    return (+v.value);
                })
            }
            setrolesPagoDeseados(rolesDeseados)
        }

        if (certificadoSeleccionado !== undefined && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_ROLES_PAGO) {
            return (
                <Row form>
                    <Col md={12}>
                        <FormGroup>
                            <Label for="dirigidoselect"> Seleccione los Roles de Pago *  </Label>
                            <Select
                                options={opcionesSelectTipoRoles}
                                closeMenuOnSelect={true}
                                // defaultValue={[opcionesSelectTipoRoles[0]]}
                                isMulti={true}
                                onChange={(value) => onChangeSelectRoles(value)}
                                placeholder={"Clic para ver opciones"}

                            />
                        </FormGroup>
                    </Col>
                </Row>

            )
        }
        return undefined;
    }, [certificadoSeleccionado, rolesPagoDeseados])


    const SelectMonthYear = useMemo(() => {

        function HandleChangeSelect(date: any, tipo: "desde" | "hasta") {
            if (tipo === "desde") {

                setrangoFechasDatePicker({
                    ...rangoFechasDatePicker,
                    fechaDesde: date

                })
            }
            else {

                setrangoFechasDatePicker({
                    ...rangoFechasDatePicker,
                    fechaHasta: date

                })
            }
        }

        if (certificadoSeleccionado?.idCertificado === ID_CERTIFICADO_ROLES_PAGO) {
            const MENSAJE_ERROR = "La fecha fin debe ser mayor o igual a la fecha inicio";
            const { fechaDesde, fechaHasta } = rangoFechasDatePicker;
            var error_message = "";
            if (fechaDesde && fechaHasta) {
                error_message = fechaDesde.getTime() > fechaHasta.getTime() ? MENSAJE_ERROR : "";
            }
            else if (fechaDesde && fechaHasta === undefined) {
                error_message = MENSAJE_ERROR
            }

            const fechaActual = new Date();
            const fechaMaxima = new Date(fechaActual.getFullYear(), fechaActual.getMonth() - 1, 1);

            return (
                <React.Fragment>
                    <Row form>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="aniosselect"> Fecha Inicio Roles de Pago*</Label><br />
                                <MonthDatePicker
                                    onChange={(date) => HandleChangeSelect(date, "desde")}
                                    maxDate={format(fechaMaxima, 'yyyy/MM/dd')}

                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="aniosselect"> Fecha Fin Roles de Pago*</Label><br />
                                <MonthDatePicker
                                    onChange={(date) => HandleChangeSelect(date, "hasta")}
                                    maxDate={format(fechaMaxima, 'yyyy/MM/dd')}

                                />
                            </FormGroup>
                        </Col>
                    </Row >
                    <Row form>
                        <Col>
                            {error_message !== "" && <small className="small-error">{error_message}</small>}
                        </Col>

                    </Row>
                </React.Fragment>

            )
        }
        return undefined
    }, [certificadoSeleccionado, rangoFechasDatePicker])

    const SelectIncluirRMUCertificadoLaboral = useMemo(() => {
        const opcionesSelectRMU: SelectCombo[] = [
            {
                label: "SI",
                value: "true"
            },
            {
                label: "NO",
                value: "false"
            }
        ]

        if (certificadoSeleccionado && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_TRABAJO) {
            return (
                <Row form>
                    <Col md={12}>
                        <FormGroup>
                            <Label for="incluirRMUSelect"> ¿Incluir RMU?*  </Label>
                            <SelectItem
                                options={opcionesSelectRMU}
                                value={incluirRMU}
                                onChange={handleSelectChangeRMU}
                                placeholder=""
                                name="incluirRMUSelect"
                                id="incluirRMUSelect"
                                icon="fa-caret-right" />
                        </FormGroup>
                    </Col>
                </Row>
            )
        }
        else {
            return undefined
        }
    }, [certificadoSeleccionado, incluirRMU])

    const SelectIncluirHonorariosCertificadoCivil = useMemo(() => {
        if (certificadoSeleccionado !== undefined && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_CONTRATACIONES_CIVILES)
            return (
                <ComboIncluirOpcionCertificado
                    value={incluirHonorarios ? "true" : "false"}
                    onChange={(val) => setincluirHonorarios(val === "true")}
                    label={"Incluir Honorarios*"}
                />
            )
        else {
            return undefined;
        }
    }, [incluirHonorarios, certificadoSeleccionado])



    const SelectIncluirTipoDeContrato = useMemo(() => {

        if (certificadoSeleccionado !== undefined && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_CONTRATACIONES_CIVILES)
            return (
                <ComboIncluirOpcionCertificado
                    value={incluirTipoContrato ? "true" : "false"}
                    onChange={(val) => setincluirTipoContrato(val === "true")}
                    label={"Incluir Tipo de contrato*"}
                />
            )
        else {
            return undefined;
        }

    }, [incluirTipoContrato, certificadoSeleccionado])


    const SelectIncluirActividadesCivil = useMemo(() => {


        var tieneContratosCivilesVigentes = false;

        if (informacionCertificados && informacionCertificados.contratosUsuario && informacionCertificados.contratosUsuario.length > 0) {
            const contratosFiltrados = informacionCertificados.contratosUsuario.find(c => c.idRegimen == ID_REGIMEN_CONTRATO_CIVIL)
            tieneContratosCivilesVigentes = contratosFiltrados !== undefined;
        }

        if (certificadoSeleccionado !== undefined && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_CONTRATACIONES_CIVILES && tieneContratosCivilesVigentes)
            return (
                <ComboIncluirOpcionCertificado
                    value={incluirActividades ? "true" : "false"}
                    onChange={(val) => setincluirActividades(val === "true")}
                    label={"Incluir Actividades del último contrato*"}
                />
            )
        else {
            return undefined;
        }

    }, [incluirActividades, certificadoSeleccionado, informacionCertificados.contratosUsuario])



    const BotonEnviarSolicitud = useMemo(() => {

        var certificadoMostroVistaPrevia = certificadoPrevio.urlPDF || vistaPrevia !== undefined || certificadoSeleccionado?.idCertificado === ID_CERTIFICADO_ROLES_PAGO;

        var llenoRangoAnios = certificadoPideAnios && anioSeleccion === "ran" && anioDesde > 0 && anioHasta > 0;
        var llenoAniosParaCiviles = certificadoPideAnios && certificadoSeleccionado?.idCertificado === ID_CERTIFICADO_CONTRATACIONES_CIVILES && anioDesde > 0 && anioHasta > 0;
        var llenoAnioUnico = certificadoPideAnios && AnioUnico > 0;
        var noPideAnios = !certificadoPideAnios;
        var pideTodosLosAnios = certificadoPideAnios && anioSeleccion === "to";

        var llenaRangoFechas = certificadoSeleccionado !== undefined && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_ROLES_PAGO && rangoFechasDatePicker.fechaDesde !== undefined && rangoFechasDatePicker.fechaHasta !== undefined && rangoFechasDatePicker.fechaDesde.getTime() <= rangoFechasDatePicker.fechaHasta.getTime();



        var verificaCertRolesPagos = (llenaRangoFechas && rolesPagoDeseados.length > 0) || certificadoSeleccionado?.idCertificado !== ID_CERTIFICADO_ROLES_PAGO;


        var verificaAnios = llenoRangoAnios || llenoAnioUnico || noPideAnios || pideTodosLosAnios || llenoAniosParaCiviles;
        var verificaTerminoAcademico = (certificadoPideTermnioAca && terminoAcademico !== "") || !certificadoPideTermnioAca;

        var verificaObservaciones = certificadoSeleccionado !== undefined && ((certificadoSeleccionado.idCertificado === ID_CERTIFICADO_PERSONALIZADO && observaciones !== "") || (certificadoSeleccionado.idCertificado !== ID_CERTIFICADO_PERSONALIZADO));

        var verificaInformacionDirigido = (dirigidoSeleccion === "ot" && dirigido !== "") || dirigidoSeleccion === "re"


        if (certificadoMostroVistaPrevia && verificaAnios && verificaTerminoAcademico && verificaObservaciones && verificaInformacionDirigido && errorAnios === "" && nerrores === 0 && verificaCertRolesPagos) {
            return (
                <React.Fragment>
                    <Row form>
                        <Col md={12}>
                            <Button onClick={(e) => { setenviar(enviar + 1) }}>Enviar Solicitud</Button>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }

    }, [
        certificadoPrevio, vistaPrevia, certificadoPideAnios, anioSeleccion,
        anioDesde, anioHasta, AnioUnico, certificadoPideTermnioAca, terminoAcademico,
        certificadoSeleccionado, observaciones, dirigidoSeleccion, dirigido, errorAnios, nerrores,
        enviar, rangoFechasDatePicker, rolesPagoDeseados
    ])

    const BotonGenerarVistaPrevia = useMemo(() => {

        const botonGenerar: React.ReactElement =
            (
                <Row form>
                    <Col md={12}>
                        <Button onClick={() => setclickGenerarVistaPrevia(clickGenerarVistaPrevia + 1)}>Visualizar</Button>
                    </Col>
                </Row>
            );

        const validarEleccionContrato = certificadoSeleccionado !== undefined && (!certificadoSeleccionado.requierecontrato || (certificadoSeleccionado.requierecontrato && contratoSeleccion !== -1))
        const eleccionDirigido = dirigidoSeleccion === "ot" && dirigido || dirigidoSeleccion === "re";
        const validarEleccionAnios = certificadoSeleccionado !== undefined && certificadoPideAnios && aniosDisponibles.length > 0 && IDS_certificados_muestran_listado_anios.includes(certificadoSeleccionado.idCertificado) && listadoaniosSelect.length !== 0
        const validarEleccionAnios2 = (AnioUnico > 0 || (anioDesde > 0 && anioHasta > 0 && anioDesde <= anioHasta) || (anioSeleccion === "to"))
        const validarEleccionAniosGeneral = !certificadoPideAnios || (validarEleccionAnios && validarEleccionAnios2)


        const mostrar = certificadoSeleccionado !== undefined && tipoCertificadoSeleccion !== -1 && certificadoSeleccionado.tienevistaprevia && validarEleccionContrato && eleccionDirigido && validarEleccionAniosGeneral

        // tipoCertificadoSeleccion !== -1 &&
        // ((dirigidoSeleccion === "ot" && dirigido) || dirigidoSeleccion === "re") &&
        // (contratoSeleccion !== -1 || certificadoSeleccionado && !certificadoSeleccionado.requierecontrato) &&
        // (certificadoSeleccionado && certificadoSeleccionado.tienevistaprevia) &&
        // (
        //     (certificadoPideAnios && aniosDisponibles.length !== 0 && IDS_certificados_muestran_listado_anios.includes(certificadoSeleccionado.idCertificado) && listadoaniosSelect.length !== 0)
        //     &&
        //     (AnioUnico > 0 || (anioDesde > 0 && anioHasta > 0 && anioDesde <= anioHasta) || (anioSeleccion === "to")) || !certificadoPideAnios)
        // &&

        if (mostrar) {
            return (botonGenerar);
        }
        else {
            return undefined;
        }
    }, [tipoCertificadoSeleccion, dirigido, dirigidoSeleccion, contratoSeleccion, certificadoSeleccionado, certificadoPideAnios, aniosDisponibles, listadoaniosSelect, AnioUnico, anioDesde, anioHasta, anioSeleccion, clickGenerarVistaPrevia])


    if (loading) {
        return <Cargando />
    }

    return (
        <div className="content">


            <div className="no-margin">
                <div id="titulo_solicitud_certificado" className="mb-4"> SOLICITUD PARA EMISIÓN DE CERTIFICADOS</div>
                {
                    enviandoSolicitud &&
                    <div>
                        <Cargando mensaje="Enviando Solicitud"
                        />
                    </div>
                }
                {
                    !enviandoSolicitud &&
                    <Row>
                        {/* {DatosTablaSolicitudes.length !== 0 &&
                        <Col xl={12} className="mb-2">
                            <a className="ir_solicitudes_certificado" onClick={() => {
                                window.scrollTo(0, document.body.scrollHeight);
                            }}>Ver Solicitudes Emitidas</a>
                        </Col>
                    } */}

                        <Col xl={5}>
                            <div className="formulario_solicitud_certificado">
                                <form>
                                    {
                                        informacionCertificados.tiposCertificados.length !== 0
                                        &&
                                        <React.Fragment>
                                            <Row form>

                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label for="tipocertificadoselect"> Seleccione el Tipo de certificado* </Label>
                                                        <SelectItem
                                                            options={opcionesCertificado}
                                                            value={tipoCertificadoSeleccion}
                                                            onChange={handleSelectChangeTiposCertificados}
                                                            placeholder=""
                                                            name="tipocertificadoselect"
                                                            id="tipocertificadoselect"
                                                            icon="fa-caret-right" />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={12}>
                                                    {mensajeBloqueo}
                                                </Col>

                                            </Row>
                                            <Row form className="mb-3">
                                                <Col md={12}>
                                                    <div className="leyendaDetalleTipoCertificado">
                                                        {certificadoSeleccionado?.detalle}
                                                    </div>
                                                </Col>

                                            </Row>
                                        </React.Fragment>
                                    }
                                    {!bloqueoSeleccionContrato && tipoCertificadoSeleccion !== -1 && opcionesContrato.length !== 0 && certificadoSeleccionado && certificadoSeleccionado.requierecontrato &&
                                        <Row form>

                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="contratoselect"> Seleccione el cargo/contrato del cual desea el certificado*  </Label>
                                                    <SelectItem
                                                        options={opcionesContrato}
                                                        value={contratoSeleccion}
                                                        onChange={handleSelectChange}
                                                        placeholder=""
                                                        name="contratoselect"
                                                        id="contratroselect"
                                                        icon="fa-caret-right" />
                                                </FormGroup>
                                            </Col>

                                        </Row>


                                    }
                                    {tipoCertificadoSeleccion !== -1 && (contratoSeleccion !== -1 || certificadoSeleccionado && !certificadoSeleccionado.requierecontrato) &&
                                        <Row form>

                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="dirigidoselect"> Dirigido a: </Label>
                                                    <SelectItem
                                                        options={opcionesDirigido}
                                                        disabled={certificadoSeleccionado?.idCertificado === ID_CERTIFICADO_ROLES_PAGO}
                                                        value={dirigidoSeleccion}
                                                        onChange={handleSelectChangeDirigido}
                                                        placeholder=""
                                                        name="dirigidoselect"
                                                        id="dirigidoselect"
                                                        icon="fa-caret-right" />
                                                </FormGroup>
                                            </Col>

                                        </Row>


                                    }
                                    {
                                        tipoCertificadoSeleccion !== -1 &&
                                        (contratoSeleccion !== -1 || certificadoSeleccionado && !certificadoSeleccionado.requierecontrato) &&
                                        dirigidoSeleccion === "ot" &&
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="dirigidoselect"> Datos de la persona/empresa a quién va dirigido el certificado*  </Label>
                                                    <Input type="text" required value={dirigido} onChange={(e) => {
                                                        var texto: any = e.target.value;
                                                        if (texto && typeof (texto) === "string") {
                                                            texto = texto.toUpperCase()
                                                        }

                                                        if (texto.length <= 100) {
                                                            setdirigido(texto)
                                                        }
                                                        else{
                                                            showAlertAviso("El texto no puede ser mayor a 100 caracteres");
                                                        }
                                                        
                                                    }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    }
                                    {
                                        SelectIncluirRMUCertificadoLaboral
                                    }
                                    {
                                        SelectIncluirActividadesCivil
                                    }
                                    {
                                        //Honorarios
                                        SelectIncluirHonorariosCertificadoCivil
                                    }
                                    {
                                        SelectIncluirTipoDeContrato
                                    }
                                    {
                                        SelectMonthYear
                                    }
                                    {
                                        SelectTiposroles
                                    }

                                    {
                                        loadingDatosAdicionales &&
                                        <div className="mt-3 mb-3">
                                            <Cargando
                                                mensaje="Cargando información disponible"
                                            />
                                        </div>


                                    }
                                    {
                                        SelectAniosCertificadoCivil
                                    }
                                    {
                                        !loadingDatosAdicionales &&
                                        certificadoSeleccionado &&
                                        certificadoPideAnios &&
                                        aniosDisponibles.length !== 0 &&
                                        certificadoSeleccionado.idCertificado === ID_CERTIFICADO_EVALUACIONINTEGRAL &&
                                        listadoaniosSelect.length !== 0
                                        &&

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="aniosselect">
                                                        {certificadoSeleccionado.idCertificado === ID_CERTIFICADO_EVALUACIONINTEGRAL && "Seleccione el año de la evaluación integral para la emisión del certificado*"}
                                                    </Label>
                                                    <SelectItem
                                                        options={listadoaniosSelect}
                                                        value={AnioUnico.toString()}
                                                        onChange={(value, string) => setAnioUnico(+value)}
                                                        placeholder=""
                                                        name="aniosinicioselect"
                                                        id="aniosinicioselect"
                                                        icon="fa-caret-right" />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    }
                                    {
                                        certificadoPideAnios &&
                                        (aniosDisponibles.length !== 0 || !certificadoMuestraListadoAnios) &&
                                        IDS_certificados_piden_anios.includes(certificadoSeleccionado ? certificadoSeleccionado.idCertificado : 0) &&
                                        certificadoSeleccionado?.idCertificado !== ID_CERTIFICADO_EVALUACIONINTEGRAL && certificadoSeleccionado?.idCertificado !== ID_CERTIFICADO_ROLES_PAGO && certificadoSeleccionado?.idCertificado !== ID_CERTIFICADO_CONTRATACIONES_CIVILES &&
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="aniosselect"> Seleccione el rango de años en que desea el certificado*  </Label>
                                                    <SelectItem
                                                        options={opcionesAnios}
                                                        value={anioSeleccion}
                                                        onChange={handleSelectChangeAnio}
                                                        placeholder=""
                                                        name="aniosselect"
                                                        id="aniosselect"
                                                        icon="fa-caret-right"
                                                        isSearchable={false}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    }
                                    {
                                        listadoaniosSelect.length !== 0 &&
                                        anioSeleccion === "ran" &&
                                        (certificadoSeleccionado?.idCertificado !== ID_CERTIFICADO_EVALUACIONINTEGRAL && certificadoSeleccionado?.idCertificado !== ID_CERTIFICADO_ROLES_PAGO)
                                        &&
                                        <Row form>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="aniosinicioselect"> Año Inicio*  </Label>
                                                    <SelectItem
                                                        options={listadoaniosSelect}
                                                        value={anioDesde.toString()}
                                                        onChange={(value, string) => handleChangeanio(+value, "desde")}
                                                        placeholder=""
                                                        name="aniosinicioselect"
                                                        id="aniosinicioselect"
                                                        icon="fa-caret-right" />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="aniosfinselect"> Año Fin*  </Label>
                                                    <SelectItem
                                                        options={listadoaniosSelect}
                                                        value={anioHasta.toString()}
                                                        onChange={(value, string) => handleChangeanio(+value, "hasta")}
                                                        placeholder=""
                                                        name="aniosfinselect"
                                                        id="aniosfinselect"
                                                        icon="fa-caret-right" />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    }



                                    {
                                        listadoaniosSelect.length === 0 && !certificadoMuestraListadoAnios &&
                                        anioSeleccion === "ran"
                                        &&
                                        <Row form>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="aniosselect"> Año Inicio*  </Label>
                                                    {/* <Input
                                                        type="text"
                                                        onChange={(e) => handleChangeanio(+e.target.value, "desde")}
                                                        min={1959}
                                                        max={new Date().getFullYear()}
                                                        pattern="\d{4}"
                                                        className="input-soliccertificado"
                                                        maxlength="4"
                                                        
                                                    /> */}
                                                    <InputNumber
                                                        min={1959}
                                                        max={new Date().getFullYear()}
                                                        placeholder={"aaaa"}
                                                        digits={4}
                                                        onChange={(valor, nerrores) => handleChangeanio(+valor, "desde", nerrores)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="aniosselect"> Año Fin*  </Label>
                                                    <InputNumber
                                                        min={1959}
                                                        digits={4}
                                                        onChange={(valor, nerrores) => handleChangeanio(+valor, "hasta", nerrores)}
                                                        max={new Date().getFullYear()}
                                                        placeholder={"aaaa"}


                                                    />
                                                    {/* <Input
                                                        type="text"
                                                        onChange={(e) => handleChangeanio(+e.target.value, "hasta")}
                                                        min={1959}
                                                        max={new Date().getFullYear()}
                                                        pattern="\d{4}"
                                                        className="input-soliccertificado"
                                                        maxlength="4"
                                                    /> */}
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    }
                                    {
                                        errorAnios !== "" &&
                                        <small className="errorFormat">{errorAnios}</small>
                                    }

                                    {certificadoPideTermnioAca &&
                                        <Row form>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="terminoselect"> Seleccione el término académico* </Label>
                                                    <SelectItem
                                                        options={opcionesTermino}
                                                        value={terminoAcademico}
                                                        onChange={(value, string) => setterminoAcademico(value)}
                                                        placeholder=""
                                                        name="terminoselect"
                                                        id="terminoselect"
                                                        icon="fa-caret-right" />
                                                </FormGroup>
                                            </Col>

                                        </Row>
                                    }

                                    {
                                        //Boton Generar Vista Previa
                                        BotonGenerarVistaPrevia
                                    }



                                    {
                                        (certificadoPrevio.urlPDF !== "" || vistaPrevia || certificadoSeleccionado?.idCertificado === ID_CERTIFICADO_ROLES_PAGO)
                                        // (tipoCertificadoSeleccion !== -1 && contratoSeleccion !== -1 && certificadoSeleccionado && !certificadoSeleccionado.tienevistaprevia && vistaPrevia))
                                        // && datosIncorrectos 
                                        &&
                                        <Row form>

                                            {certificadoSeleccionado && certificadoSeleccionado.idCertificado === ID_CERTIFICADO_PERSONALIZADO &&
                                                <Col md={12} sm={12}>
                                                    <Label>Detalle la información que desea que se presente en el certificado*.</Label>
                                                    <Col md={12}>
                                                        <textarea
                                                            cols={50}
                                                            rows={5}
                                                            onChange={(e) => setobservaciones(e.target.value)}
                                                            maxLength={300}
                                                        />
                                                    </Col>
                                                    {observaciones === "" && <small className="errorFormat">Debe llenar la información para enviar la solicitud</small>}

                                                </Col>
                                            }
                                            {
                                                certificadoSeleccionado && certificadoSeleccionado.idCertificado !== ID_CERTIFICADO_PERSONALIZADO &&
                                                <Col md={12} sm={12}>
                                                    <Label>Si tiene alguna observación con respecto a la emisión de este certificado, favor indíquelo en este casillero.</Label>
                                                    <div className="miniContainertextArea">
                                                        <textarea
                                                            className=""
                                                            cols={50}
                                                            rows={5}
                                                            onChange={(e) => setobservaciones(e.target.value)}
                                                            maxLength={300}
                                                        />
                                                    </div>


                                                </Col>
                                            }
                                        </Row>
                                    }


                                    {
                                        BotonEnviarSolicitud
                                    }




                                </form>
                            </div>
                        </Col>
                        <Col xl={7} sm={12}>
                            <form>
                                <Row form>

                                    <Col md={12}>
                                        <FormGroup>
                                            {loadingVistaPrevia &&
                                                <div><Cargando mensaje="Cargando Certificado" /></div>
                                            }
                                            {!loadingVistaPrevia && vistaPrevia}

                                        </FormGroup>
                                    </Col>

                                </Row>


                            </form>

                        </Col>
                    </Row>
                }

                {DatosTablaSolicitudes.length !== 0 &&
                    <Row>
                        <Col xl={12}>
                            <div className="titulo_tabla_solicitudes_cert">Historia de Solicitudes Realizadas</div>
                        </Col>
                        <Col xl={12}>
                            <TableSolicitudesCertificados
                                handleDescargarCertificado={(referencia: string) => HandleDescargarCertificado(referencia)}
                                dataprops={DatosTablaSolicitudes}
                                handleAnularSolicitud={(idSolicitud: number) => setidSolicitudAnular(idSolicitud)}

                            />
                        </Col>
                    </Row>
                }
                {
                    <Modal
                        isOpen={loadingButtonDescarga}
                        scrollable={true}
                        fullscreen={"xl"}
                        centered={true}
                        onClosed={() => setloadingButtonDescarga(false)}
                    >
                        <ModalBody>
                            <div><Cargando /></div>
                        </ModalBody>
                    </Modal>
                }
                <ModalConfirmacion
                    nombreBotonAccion="Confirmar Anulación"
                    mensajeConfirmacion="¿Está seguro/a que desea anular la solicitud de certificado?"
                    size="md"
                    show={idSolicitudAnular !== -1}
                    onClose={() => setidSolicitudAnular(-1)}
                    asyncAccion={true}
                    asyncClose={true}
                    nombreBotonAfterOnClose={"Actualizar Tabla"}
                    asyncOnClick={async () => await AnulacionCertificado()}
                    asyncAfterOnClose={async () => await CerrarModalConfirmacionYActualizar()}
                    closeAfterAccion={true}
                    hideBotonCerrar={true}
                    colorButtonAccion="secondary"

                />



            </div>





        </div>
    )
}
